function setupTabs( root ) {
	const breakpoint = parseInt( root.dataset.mobileBreakpoint || '767', 10 );
	const mobileQuery = window.matchMedia( `(max-width: ${ breakpoint }px)` );

	const tabs = Array.from(
		root.querySelectorAll( ':scope > .tribe-blocks-tabs__nav .tribe-blocks-tabs__tab' )
	);

	const accordions = Array.from(
		root.querySelectorAll( ':scope > .tribe-blocks-tabs__panels > .tribe-blocks-tabs__accordion-trigger' )
	);

	const panels = Array.from(
		root.querySelectorAll( ':scope > .tribe-blocks-tabs__panels > .wp-block-tribe-blocks-tab-panel' )
	);

	if ( ! tabs.length || ! panels.length ) {
		return;
	}

	let activeIndex = parseInt( root.dataset.activeTab || '0', 10 );

	if (
		Number.isNaN( activeIndex ) ||
		activeIndex < 0 ||
		activeIndex >= panels.length
	) {
		activeIndex = 0;
	}

	function setDesktopState( index, moveFocus = false ) {
		activeIndex = index;
		root.dataset.activeTab = index;

		tabs.forEach( ( tab, i ) => {
			const selected = i === index;
			tab.setAttribute( 'aria-selected', selected ? 'true' : 'false' );
			tab.setAttribute( 'tabindex', selected ? '0' : '-1' );
			tab.classList.toggle( 'is-active', selected );
		} );

		accordions.forEach( ( trigger, i ) => {
			const expanded = i === index;
			trigger.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
			trigger.classList.toggle( 'is-active', expanded );
		} );

		panels.forEach( ( panel, i ) => {
			panel.hidden = i !== index;
		} );

		if ( moveFocus && tabs[ index ] ) {
			tabs[ index ].focus();
		}
	}

	function setMobileState( index, allowCollapse = true ) {
		const isExpanded =
			accordions[ index ].getAttribute( 'aria-expanded' ) === 'true';

		accordions.forEach( ( trigger, i ) => {
			let expanded = false;

			if ( i === index ) {
				expanded = allowCollapse ? ! isExpanded : true;
			}

			trigger.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
			trigger.classList.toggle( 'is-active', expanded );
			panels[ i ].hidden = ! expanded;
		} );

		activeIndex = isExpanded && allowCollapse ? -1 : index;
		root.dataset.activeTab = activeIndex;
	}

	function applySemantics() {
		if ( mobileQuery.matches ) {
			const nav = root.querySelector( ':scope > .tribe-blocks-tabs__nav' );
			if ( nav ) {
				nav.setAttribute( 'aria-hidden', 'true' );
			}

			tabs.forEach( ( tab ) => {
				tab.setAttribute( 'tabindex', '-1' );
			} );

			panels.forEach( ( panel, i ) => {
				panel.setAttribute( 'role', 'region' );
				panel.setAttribute( 'aria-labelledby', accordions[ i ].id );
			} );

			if ( activeIndex < 0 || activeIndex >= panels.length ) {
				panels.forEach( ( panel ) => {
					panel.hidden = true;
				} );
				accordions.forEach( ( trigger ) => {
					trigger.setAttribute( 'aria-expanded', 'false' );
					trigger.classList.remove( 'is-active' );
				} );
			} else {
				accordions.forEach( ( trigger, i ) => {
					const expanded = i === activeIndex;
					trigger.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
					trigger.classList.toggle( 'is-active', expanded );
				} );

				panels.forEach( ( panel, i ) => {
					panel.hidden = i !== activeIndex;
				} );
			}
		} else {
			const nav = root.querySelector( ':scope > .tribe-blocks-tabs__nav' );
			if ( nav ) {
				nav.removeAttribute( 'aria-hidden' );
			}

			panels.forEach( ( panel, i ) => {
				panel.setAttribute( 'role', 'tabpanel' );
				panel.setAttribute( 'aria-labelledby', tabs[ i ].id );
			} );

			if ( activeIndex < 0 ) {
				activeIndex = 0;
			}

			setDesktopState( activeIndex, false );
		}
	}

	tabs.forEach( ( tab, index ) => {
		tab.addEventListener( 'click', () => {
			if ( mobileQuery.matches ) {
				return;
			}

			setDesktopState( index, true );
		} );

		tab.addEventListener( 'keydown', ( event ) => {
			if ( mobileQuery.matches ) {
				return;
			}

			let nextIndex = null;

			switch ( event.key ) {
				case 'ArrowRight':
				case 'Right':
					nextIndex = ( index + 1 ) % tabs.length;
					break;
				case 'ArrowLeft':
				case 'Left':
					nextIndex = ( index - 1 + tabs.length ) % tabs.length;
					break;
				case 'Home':
					nextIndex = 0;
					break;
				case 'End':
					nextIndex = tabs.length - 1;
					break;
				default:
					return;
			}

			event.preventDefault();
			setDesktopState( nextIndex, true );
		} );
	} );

	accordions.forEach( ( trigger, index ) => {
		trigger.addEventListener( 'click', () => {
			if ( ! mobileQuery.matches ) {
				return;
			}

			setMobileState( index, true );
		} );
	} );

	applySemantics();

	if ( typeof mobileQuery.addEventListener === 'function' ) {
		mobileQuery.addEventListener( 'change', applySemantics );
	} else {
		mobileQuery.addListener( applySemantics );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.wp-block-tribe-blocks-tabs' )
		.forEach( setupTabs );
} );